var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M15.9999 2.6664C23.3532 2.6664 29.3332 8.64774 29.3332 15.9997C29.3332 23.3517 23.3532 29.3331 15.9999 29.3331C8.64787 29.3331 2.66653 23.3517 2.66653 15.9997C2.66653 8.64774 8.64787 2.6664 15.9999 2.6664Z",
    fill: "#034766"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0767 10.3721C14.3313 10.3721 14.5873 10.4695 14.782 10.6641L19.4313 15.2908C19.6193 15.4788 19.7247 15.7335 19.7247 16.0001C19.7247 16.2655 19.6193 16.5201 19.4313 16.7081L14.782 21.3375C14.3913 21.7268 13.7593 21.7268 13.3687 21.3348C12.9793 20.9428 12.9807 20.3095 13.3713 19.9201L17.3087 16.0001L13.3713 12.0801C12.9807 11.6908 12.9793 11.0588 13.3687 10.6668C13.5633 10.4695 13.8207 10.3721 14.0767 10.3721Z",
    fill: "#034766"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.d7a15870.svg";
export { ForwardRef as ReactComponent };